<template>
  <div :class="$store.state.hiddenBar ? '' : 'father'">
    <nav :class="$store.state.hiddenBar ? '' : 'overlay'">
      <div class="sectioninfo">
        <a  value="menuSistemas" href="https://engenhariapb.tutilabs.com.br/" >
        <div class="logo" @click="menu"></div> 
        </a>
        <div class="titleRRIM">
          <!-- <a class="buttonBack" value="menuSistemas" href="https://engenhariapb.tutilabs.com.br" >
          </a> -->
          <h4 class="title">{{ titleText }}</h4>
        </div>
      </div>
      <div class="menusection">
        <span style="font-size: 0.6rem">Versão 2.0.0</span>
        <button @click="options" class="options">
        </button>
        <button @click="menu" class="menu">
        </button>
      </div>
    </nav>
    <div class="blurringbackground" :class="{ 'show': transitionMenu }">
    </div>
    <div class="noTransitionMenu" :class="{ transitionMenu }">
      <div class="heightAdmin">
        <div class="cardAdmin">
          <div class="menuAdmin">
            <div class="adminReport">
              <div class="iconsystems"></div>
              <h3>Sistemas</h3>
              <ul>
                <li>
                  <a href="https://rrimpb.tutilabs.com.br/" target="_blank">RRIM</a>
                </li>
                <li>
                  <a href="https://stryoutpb.tutilabs.com.br/" target="_blank">Solicitação de TryOut</a>
                </li>
                <li>
                  <a href="https://rtryoutpb.tutilabs.com.br/" target="_blank">Relatório de TryOut</a>
                </li>
                <li>
                  <a href="https://fitpb.tutilabs.com.br/" target="_blank">FIT - Ficha de Instrução de Trabalho</a>
                </li>
                <li>
                  <a href="https://ftijpa.tutilabs.com.br/" target="_blank">
                    FTI - Ficha Técnica de Injeção</a>
                </li>
              </ul>
            </div>
            <div class="adminUser">
              <div class="iconuser"></div>
              <h3>Informações do usuário</h3>
              <p>
                <strong>Nome:</strong>
                {{ $store.state.user.nome_completo }}
              </p>
              <p>
                <strong>Matricula:</strong>
                {{ $store.state.user.matricula }}
              </p>
              <p>
                <strong>Email:</strong>
                {{ $store.state.user.email }}
              </p>
              <p>
                <strong>Cargo:</strong>
                {{ $store.state.user.cargo.descricao }}
              </p>
              <p>
                <strong>Nível de Acesso:</strong>
                {{ $store.state.user.nivel_de_acesso.descricao }}
              </p>
            </div>
            <ChangePassword v-if="showPassword" @showChangePassword="showChangePassword" />
          </div>
          <div class="containerExit">
            <div class="logout" @click="logout">
              <p>Sair</p>
              <div class="outside"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="noTransitionoptions" :class="{ transitionoption }"  v-if="showOptions">
      <div class="option">
        <span tabindex="0" @click="approved" :class="{ selectedoption: activeOption === 'approved' }">
          <div class="approvedicon"></div>Aprovados
        </span>
      </div>
      <div class="option">
        <span tabindex="0" @click="rejected" :class="{ selectedoption: activeOption === 'rejected' }">
          <div class="rejectedicon"></div>Reprovados
        </span>
      </div>
      <div class="option">
        <span tabindex="0" @click="homologation" :class="{ selectedoption: activeOption === 'homologation' }">
          <div class="homologationicon"></div>Em Homologação
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showOptions: false,
      transitionMenu: false,
      showPassword: false,
      blurring: false,
      transitionoption: false,
      activeOption: 'homologation',
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$store.commit('SET_HOMOLOGATION');
    window.addEventListener("resize", this.updateWidth);
    document.addEventListener("click", this.handleClickOutside);
  },
  computed: {
    titleText() {
      return this.windowWidth < 500 ? "RRIM" : "Relatório de Recebimento e Introdução de Molde";
    },
  },
  methods: {
    handleClickOutside(event) {
      const menu = this.$el.querySelector(".noTransitionMenu");
      const options = this.$el.querySelector(".noTransitionoptions");
      if (
        this.transitionMenu &&
        menu &&
        !menu.contains(event.target) &&
        !event.target.closest(".menu")
      ) {
        this.transitionMenu = false;
        this.$store.commit("setIcon", !this.$store.state.removeicons);
      }
      if (
        this.transitionoption &&
        options &&
        !options.contains(event.target) &&
        !event.target.closest(".options")
      ) {
        this.transitionoption = false;
      }
    },
    approved() {
      this.activeOption = 'approved';
      this.$store.commit('SET_APPROVED');
      this.showOptions = false;
    },
    rejected() {
      this.activeOption = 'rejected';
      this.$store.commit('SET_REJECTED');
      this.showOptions = false;
    },
    homologation() {
      this.activeOption = 'homologation';
      this.$store.commit('SET_HOMOLOGATION');
      this.showOptions = false;
    },
    updateWidth() {
      this.windowWidth = window.innerWidth;
    },
    menu() {
      this.transitionMenu = !this.transitionMenu;
      this.$store.commit("setIcon", !this.$store.state.removeicons);
    },
    options() {
      this.transitionoption = !this.transitionoption;
      this.showOptions = true;
    },
    showChange() {
      this.showPassword = !this.showPassword;
    },
    logout() {
      document.cookie = 'auth._token.local=false;path=/; domain=.tutilabs.com.br'
      document.cookie = 'auth._token_expiration.local=false;path=/; domain=.tutilabs.com.br'
      window.location.replace('https://engenhariapb.tutilabs.com.br/login')
    },
    showChangePassword() {
      this.showPassword = false;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.father {
  display: flex;
  align-items: center !important;
  justify-content: center;
  margin-top: 2.1rem;

}

nav {
  display: flex;
  background-color: var(--gray_header);
  width: 100%;
  padding: 0.1rem 1.5rem;
  justify-content: space-between;

}

.overlay {
  position: fixed;
  z-index: 9;
}

.sectioninfo {
  display: flex;
  align-items: center;
}

.logo {
  width: 7rem;
  height: 4rem;
  background: url('../../../../public/img/engdigitallogo.svg');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  cursor: pointer;
}

.titleRRIM {
  display: flex;
  align-items: center;
  padding: 0 1rem;
}

.title {
  font-family: Poppins, sans-serif;
  font-weight: 500;
  color: var(--gray_header_font) !important;
  font-size: 1.7rem!important;
}

.sectioninfo {
  display: flex;
}

.menusection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 10rem;
}

.menu {
  background: url("../../../static/icons/user.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  width: 2rem;
  height: 2rem;
}

.options {
  background: url("../../../static/icons/menu.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  width: 2rem;
  height: 2rem;
}

.blurringbackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
  transition: opacity 0.3s ease, visibility 0.3s ease;
  visibility: hidden;
  opacity: 0;
  z-index: 3;
}


.blurringbackground.show {
  visibility: visible;
  opacity: 1;
}

.noTransitionMenu.transitionMenu {
  width: 100%;
  transition: 1.2s;
  margin-top: 28.5rem;
  z-index: 3;
  visibility: visible;
}

.noTransitionMenu {
  display: flex;
  width: 100%;
  transition: 1.2s;
  margin-top: -100vh;
  position: fixed;
  z-index: 3;
  justify-content: center;
  align-items: center;
  visibility: hidden;

}

.noTransitionoptions {
  visibility: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 2rem;
  right: 5.7vw;
  z-index: 10;
  width: 14rem;
  padding: 0.25rem;
  border-radius: 4px;
  background-color: white;
  box-shadow: 1px 4px 6px -1px rgba(0, 0, 0, 0.1);
  gap: 0.5rem;
  opacity: 0;

}

.noTransitionoptions .option {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Poppins, sans-serif;
  font-size: 1rem;
  width: 13.9rem;
  border-radius: 2px;
  cursor: pointer;
  padding: 0.5rem;
}

.noTransitionoptions span {
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 0.4rem;
  font-family: Poppins, sans-serif;
  color: var(--font_color);
  padding: 0.5rem;
  width: 98%;
  border-radius: 6px;
}

.noTransitionoptions .option:hover {
  background-color: var(--gray_homologation);
  border-radius: 0.5rem;
}

.selectedoption {
  background-color: var(--font_color);
  color: white !important;

  .approvedicon {
    background-image: url(../../../static/icons/check-square_white.svg) !important;
  }

  .homologationicon {
    background-image: url(../../../static/icons/edit_white.svg) !important;
  }

  .rejectedicon {
    background-image: url(../../../static/icons/thumbs-down_white.svg) !important;
  }
}

.noTransitionoptions.transitionoption {
  visibility: visible;
  opacity: 1;
  transition: 0.5s;
  top: 3.3rem;
}

.heightAdmin {
  width: 100% !important;
  background: white;
}

.cardAdmin {
  padding: 1.3rem;
}

.menuAdmin {
  display: flex;
  width: 100%;
}

.iconsystems {
  width: 7rem !important;
  background-image: url(../../../static/icons/monitor.svg);
  background-repeat: no-repeat;
  background-position: left;
  background-size: 48%;
  height: 3rem;
  margin-left: 0.5rem;

}

.iconuser {
  width: 7rem !important;
  background-image: url(../../../static/icons/user.svg);
  background-repeat: no-repeat;
  background-position: left;
  background-size: 48%;
  height: 3rem;
  margin-left: 0.5rem;
}

.adminReport {
  padding: 1rem !important;
}

.adminReport,
.adminOption {
  padding: 1rem;
  border: 1rem;
  width: 50%;
}

.adminReport h3 {
  font-family: Poppins, sans-serif;
  color: var(--gray_font);
  font-size: 1.3rem;
  font-weight: bold;
  padding: 0 0.5rem 0.8rem;
}

ul {
  list-style: none;

}

ul li {
  padding: 0.5rem;
}

ul li:hover {
  background-color: var(--gray_hover);
}

ul li a {
  font-family: Poppins, sans-serif;
  color: var(--gray_font);
  font-size: 1rem;
}

.containerExit {
  border-top: 1px solid gray;
  padding: 1rem 1rem 0;
}

.adminUser {
  width: 50%;
  padding: 1rem;
}

.adminUser h3 {
  font-family: Poppins, sans-serif;
  color: var(--gray_font);
  font-size: 1.3rem;
  font-weight: bold;
  padding: 0 0.5rem 0.8rem;
}

.adminUser p {
  font-family: Poppins, sans-serif;
  color: var(--gray_font);
  font-size: 1rem;
}

.adminUser p,
h3 {
  padding: 0.5rem;
}

.logout {
  display: flex;
  justify-content: right;
}

.logout p {
  display: flex;
  align-items: center;
  font-family: Poppins, sans-serif !important;
}

.outside {
  background-image: url(../../../static/icons/outsideHouse.svg);
  background-repeat: no-repeat;
  background-position: center;
  height: 2rem;
  width: 3rem;
}

.approvedicon {
  background-image: url(../../../static/icons/check-square_dark.svg);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5rem !important;
  height: 1.5rem !important;
}

.homologationicon {
  background-image: url(../../../static/icons/edit_dark.svg);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5rem !important;
  height: 1.5rem !important;
}

.rejectedicon {
  background-image: url(../../../static/icons/thumbs-down_dark.svg);
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5rem !important;
  height: 1.5rem !important;
}

@media(max-width: 964px) {
  .title {
    font-size: 1.1rem!important;
  }
}

@media(max-width: 639px) {
  .noTransitionMenu.transitionMenu {
    margin-top: 30rem;

  }
}

@media(max-width: 524px) {

  .noTransitionMenu.transitionMenu {

}
  .noTransitionMenu.transitionMenu {
    margin-top: 47rem;

  }

  .menuAdmin {
  flex-direction: column!important;
}

.cardAdmin {
  max-height: calc(94.5vh - 2rem);
  overflow-y: auto;
}

.adminReport, .adminUser {
  width: 100%!important;
}
}

</style>
